module.exports = __webpack_public_path__ + "img/import_grey.0406e914.svg";